'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSenderId = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reselect = require('reselect');

var _getIsAdmin = require('../clientSelectors/getIsAdmin');

var _getUserId = require('../userSelectors/getUserId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessagesUtk = (0, _getIn2.default)(['prospectUtks', 'messagesUtk']);

var getSenderId = exports.getSenderId = (0, _reselect.createSelector)([_getIsAdmin.getIsAdmin, _getUserId.getUserId, getMessagesUtk], function (isAdmin, userId, messagesUtk) {
  if (isAdmin) return '' + userId;
  return messagesUtk;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/pubNubMessageSelectors/getSenderId.js
// module id = 149
// module chunks = 2 3